<template>
  <v-container>
    <template v-if="loading">
      <v-row justify="start" align-content="center" class="mt-10">
        <img src="../../assets/loading.gif">
      </v-row>
    </template>
    <template v-else>
      <v-card-title class="pa-5 pb-3">
        <p class="font-weight-bold">基本情報</p>
      </v-card-title>
      <v-card-text class="pa-5 pt-0">
        <ValidationObserver ref="observer" v-slot="{ invalid }">
          <v-form ref="form" v-on:submit.prevent="userInfoUpdate">
            <v-row class="align-center">
              <v-avatar size="120" depressed class="mr-4">
                <v-img :src="iconPreview" alt="icon" max-height="120" max-width="120"></v-img>
              </v-avatar>
              <ValidationProvider name="アイコン" rules="" v-slot="{ errors }">
                <v-btn
                  @click="iconDelete"
                  depressed
                  color="#EDEDED"
                  class="mr-4 textColor--#333333 font-weight-bold"
                >削除する</v-btn>
                <v-btn
                  depressed
                  dark
                  color="#5E00BC"
                  @click="iconUpload"
                  accept=".jpg, .jpeg, .png"
                  :error-messages="errors"
                  class="font-weight-bold"
                >アイコンを変更する</v-btn>
                <input
                  style="display: none"
                  ref="input"
                  type="file"
                  accept="image/jpeg, image/jpg, image/png"
                  @change="selectedFile()"
                >
              </ValidationProvider>
              <v-spacer></v-spacer>
            </v-row>
            <v-row class="pt-2">
              <v-col cols="12" md="5">
                <ValidationProvider name="ユーザー名" rules="required|max:30" v-slot="{ errors }">
                  <span class="font-weight-bold">ユーザー名</span>
                  <v-text-field
                    full-width: false
                    v-model="user.name"
                    :error-messages="errors"
                    color="black"
                    class="pt-0"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5">
                <ValidationProvider name="ユーザーコード" rules="min:8|max:15|userCodeRegex" v-slot="{ errors }">
                  <span class="font-weight-bold">ユーザーコード</span>
                  <v-text-field
                    v-model="user.user_code"
                    :error-messages="errors"
                    class="pt-0"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5">
                <ValidationProvider name="年齢" rules="integer|min_value:1|max_value:999" v-slot="{ errors }">
                  <span class="font-weight-bold">年齢</span>
                  <v-text-field
                    v-model="user.age"
                    :error-messages="errors"
                    class="pt-0"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5">
                <span class="font-weight-bold">性別</span>
                <v-select
                  :items="gender"
                  item-text="label"
                  item-value="value"
                  v-model="user.gender"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5">
                <span class="font-weight-bold">都道府県</span>
                <v-select
                  :items="prefecture"
                  v-model="user.prefecture"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5">
                <span class="font-weight-bold">住所</span>
                <ValidationProvider name="住所" rules="min:1|max:100" v-slot="{ errors }">
                  <v-text-field
                    v-model="user.address"
                    :error-messages="errors"
                    class="pt-0"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5">
                <span class="font-weight-bold">好きな技術</span>
                <ValidationProvider name="好きな技術" rules="min:1|max:100" v-slot="{ errors }">
                  <v-text-field
                    v-model="user.favorite_technology"
                    :error-messages="errors"
                    class="pt-0"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5">
                <span class="font-weight-bold">エンジニア歴</span>
                <ValidationProvider name="エンジニア歴" rules="integer|min_value:0|max_value:99" v-slot="{ errors }">
                  <v-text-field
                    v-model="user.career"
                    :error-messages="errors"
                    class="pt-0"
                    suffix="年"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5">
                <span class="font-weight-bold">自己紹介</span>
                <ValidationProvider name="説明" rules="max:3000" v-slot="{ errors }">
                  <v-textarea
                    outlined
                    v-model="user.introduction_text"
                    :error-messages="errors"
                    class="pt-0"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5" class="text-center">
                <v-btn
                  dark
                  color="#5E00BC"
                  class="button-shadow ma-4 font-weight-bold"
                  width="50%"
                  type="submit"
                  :disabled="invalid"
                >変更する</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-card-text>
    </template>
    <CropperModal 
      style="width:100%;"
      :isCropperOpen="isOpenCropperModal" 
      :isCropperClose="closeCropperModal" 
      :imgSrc="imgSrc" 
      @sendImage="emitImage" />
  </v-container>
</template>
<script>
import CropperModal from '../organisms/CropperModal.vue'

export default {
  name: 'UserEditBase',
  components: {
    CropperModal,
  },
  data() {
    return {
      selectedItem: 0,
      user: {
        icon_url: '',
        name: '',
        user_code: '',
        introduction_text: '',
        age: null,
        gender: '',
        prefecture: '',
        address: '',
        favorite_technology: '',
        career: null,
        is_released: false,
        email: '',
      },
      preview: null,
      icon: null,
      loading: true,
      gender: [
        {label: '', value: ''},
        {label: '男性', value: 'man'},
        {label: '女性', value: 'woman'},
      ],
      prefecture: [
        '', '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県',
        '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県',
        '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県',
        '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県',
        '大分県', '宮崎県', '鹿児島県', '沖縄県', 'その他'
      ],
      isOpenCropperModal: false, 
      imgSrc: '',
    };
  },
  computed: {
    getUserCode() {
      return this.$store.getters['auth/isUserCode']
    },
    iconPreview() {
      return this.preview;
    },
  },
  methods: {
    getUserInfo() {
      this.$store.dispatch('userinfo/get')
        .then(() => {
          this.user = this.$store.getters['userinfo/getUser']
          this.setIcon()
          this.loading = false;
        });
    },
    setIcon() {
      this.preview = this.user.icon_url;
    },
    userInfoUpdate() {
      this.loading = true;
      if(this.user.user_code ===  this.getUserCode) {
        delete this.user.user_code
      }
      this.$store.dispatch('userinfo/updateInfo', this.user)
        .then(() => {
          if(this.user.user_code){
            this.$store.dispatch('auth/updateUserCode', this.user.user_code);
          }
          if (this.icon){
            this.$store.dispatch('userinfo/updateIcon', this.icon, {
              headers: { 'content-type': 'multipart/form-data' }
            })
          }
          setTimeout(function() {
            location.reload();
          }.bind(this), 3000);
        })
    },
    iconUpload() {
      this.$refs.input.click();
    },
    async selectedFile() {
      this.isUploading = true;

      let file = this.$refs.input.files[0]
      if (!file) {
        return;
      }
      let size = file.size;
      let type = file.type;
      let errors = '';
      //上限サイズ20MB
      if (size > 20000000) {
        errors += 'ファイルの上限サイズ20MBを超えています\n'
      }
      //拡張子は .jpg .png .jpg のみ許可
      if (type != 'image/jpeg' && type != 'image/png' && type != 'image/jpg') {
        errors += '.jpg、.png、.jpgのいずれかのファイルのみ許可されています\n'
      }
      if (errors) {
        //errorsが存在する場合は内容をalert
        this.$swal('エラー', errors, 'error')
        //valueを空にしてリセットする
        this.icon = null;
        this.preview = null;
      } else {
        if (typeof FileReader === 'function') {
          const reader = new FileReader()
          reader.onload = (event) => {
            this.imgSrc = event.target.result
          }
          reader.readAsDataURL(file)
          setTimeout(function() {
              this.isOpenCropperModal = true;
            }.bind(this), 500);
          }
      }
    },
    emitImage(base64File) {
      // ファイルをバイナリ化
      let bin = atob(base64File.replace(/^.*,/, ''));
      // バイナリデータに変換
      let buffer = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) {
          buffer[i] = bin.charCodeAt(i);
      }
      // Fileオブジェクトの生成
      let image_file = new File([buffer.buffer], "aaa", {type: 'png'});
      this.preview = URL.createObjectURL(image_file);
      const data = new FormData()
      data.append('icon', image_file)
      this.icon = data
    },
    iconDelete() {
      if (this.preview != process.env.VUE_APP_IMAGE_BUCKET_URL + '/icon/default_user_icon.svg') {
        this.preview = process.env.VUE_APP_IMAGE_BUCKET_URL + '/icon/default_user_icon.svg';
        this.user.icon_url = process.env.VUE_APP_IMAGE_BUCKET_URL + '/icon/default_user_icon.svg';
        if (this.icon != null) {
          document.getElementById('inputFile').value = ''
        }
      } 
      if (this.icon) {
        this.icon = null
      }
    },
    linkToProfile() {
      this.$router.push({name: 'user', params: {user_code: this.user.user_code}})
    },
    closeCropperModal() {
      this.isOpenCropperModal = false;
    }
  },
  created() {
    return this.getUserInfo()
  }
}
</script>